















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DataTypeExplorer from '@/components/designer/DataTypeExplorer.vue';
import { TreeNode } from '@/libs/com/MetaPattern/Product/IDE/Util/TreeNode';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';

@Component({
  components: {
    DataTypeExplorer
  }
})
export default class PGRowDataTypeValue extends Vue {
  @Prop() private value!: string | BaseElement;
  @Prop() private includePlatType!: boolean; // 是否包含平台类型
  @Prop() private beTypes!: number; // 实体组件类型过滤，0代表所有类型，使用枚举EnumBEType的值之和
  @Prop() private isEditable!: boolean;
  @Prop() private isSelfAPP: boolean; // 是否只是自己应用下的类型，对于数据类型为Reference，这个值为true
  private dialogVisible = false;
  private dataType = '';
  private dataObj = null as BaseElement;

  selectDataType(node: TreeNode<BaseElement>) {
    this.dataObj = node.data;
    if (node.data && (node.data as any).component) {
      this.dataType = (node.data as any).component.rootNamespace + '.' + node.nodeValue;
    } else {
      // todo: 通过ID查找方式仅适用于运行期,设计期需要通过designId查找
      const component = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.id === (node.data as any).component_ID);
      if (component) this.dataType = component.rootNamespace + '.' + node.nodeValue;
      else this.dataType = node.nodeValue;
    }
  }

  get valueTitle() {
    if (this.value instanceof BaseElement) {
      return this.value.name;
    }
    return this.value;
  }

  set valueTitle(value: string | BaseElement) {
    this.value = value;
  }

  valueChanged(): void {
    if (this.dataType === '') {
      this.$message({ type: 'warning', message: '请选择具体的类型!' });
    } else {
      this.dialogVisible = false;
      this.$emit('valueChanged', this.dataType, this.dataObj);
    }
  }

  clearValue(): void {
    this.dialogVisible = false;
    this.dataType = '';
    this.dataObj = null;
    this.$emit('valueChanged', this.dataType, this.dataObj);
  }
}
